import type { StateTree } from '@makemydeal/dr-dash-types';
import type { SharingType } from '../types/types';

export const isLoading = (state: StateTree): boolean => {
    return state.printPdf.loading;
};

export const isForSharing = (state: StateTree): boolean => {
    return state.printPdf.forSharing;
};

export const isPublishing = (state: StateTree): boolean => {
    return !!state.printPdf.isPublishing;
};

export const getSharingUrl = (state: StateTree): string | undefined => {
    return state.printPdf.sharingUrl;
};

export const getSharingType = (state: StateTree): SharingType | undefined => {
    return state.printPdf.sharingType;
};

export const isSuccess = (state: StateTree): boolean => {
    return state.printPdf.isSuccess;
};

export const isError = (state: StateTree): boolean => {
    return state.printPdf.isError;
};
